import { useMemo } from 'react';
import { useTheme } from '../../../../hooks/useTheme';
import { SelectField } from '../SelectField';
import data3dprint from '../../../../config/data3dprint.json';

interface AdditionalServicesFieldProps {
  value: number | undefined;
  onChange: (value: string) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  isActive?: boolean;
  disabled?: boolean;
  selectedTechnology: string;
  selectedPrinter: number | undefined;
  selectedMaterial: number | undefined;
  selectedColor: number | undefined;
  selectedInfill: number | undefined;
  selectedQuality: number | undefined;
}

export function AdditionalServicesField({
  value,
  onChange,
  onFocus,
  onBlur,
  isActive = false,
  disabled = false,
  selectedTechnology,
  selectedPrinter,
  selectedMaterial,
  selectedColor,
  selectedInfill,
  selectedQuality
}: AdditionalServicesFieldProps) {
  const theme = useTheme(state => state.getThemeStyles());

  const options = useMemo(() => {
    const technology = data3dprint.technologies.find(
      tech => tech.name === selectedTechnology
    );
    
    const printer = technology?.printers.find(
      p => p.id === selectedPrinter
    );

    if (!technology || !printer) return [];

    return printer.additional_services.map(service => ({
      id: service.id,
      name: service.label,
      label: `${service.label} - R$ ${service.price.toFixed(2)}`
    }));
  }, [selectedTechnology, selectedPrinter]);

  const isDisabled = disabled || 
    !selectedTechnology || 
    !selectedPrinter || 
    !selectedMaterial || 
    !selectedColor ||
    !selectedInfill ||
    !selectedQuality;

  return (
    <div className={theme.components.input.variants.select.group}>
      <label 
        htmlFor="additionalServices"
        className={`
          ${theme.components.input.variants.select.label.base}
          ${isDisabled ? theme.components.input.variants.select.label.disabled : ''}
        `}
      >
        Serviços Adicionais
      </label>
      <SelectField
        name="additionalServices"
        label="Serviços Adicionais"
        options={options}
        value={value}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        isActive={isActive}
        disabled={isDisabled}
      />
    </div>
  );
} 